'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$uibModal',
    function($modal) {
        return {
            open: open
        };

        function open() {
            return $modal.open({
                template: require('../view/prepare-print.html'),
                controller: 'PrintController',
                backdrop: false,
                size: 'md',
                resolve: {
                },
            });
        }
    }];
